export default __webpack_public_path__ + "37b2892444c9d96d71f3a12d4111e18f.svg";